export default __webpack_public_path__ + "static/meshmark-13223f1981b373e96c30c16f695f119f.webp";